import React, { useEffect, useState,useMemo  } from "react";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";
import { graphData } from "../../services/api";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
);

// Custom Tick Plugin
const customPressureTicksPlugin = {
  id: 'customPressureTicks',
  beforeInit(chart) {
    if (
      chart.options &&
      chart.options.scales &&
      chart.options.scales.yPressure
    ) {
      chart.options.scales.yPressure.afterBuildTicks = function (axis) {
        axis.ticks = [-88.5, -80, -70, -60, -50, -40, -30, -20, -10, 0, 10, 20, 30, 40, 50, 61, 66.5];
      };
    }
  }
};
const RebaseISGraphChartjs = ({ data, deviceId, height = 500,alarm,action,maximum }) => {

 
  const [datasets, setDatasets] = useState([]);

  const roundDownToFive = (num) => Math.abs(num / 5) * 5;
const rounded = (num)  =>Math.round(Math.abs(num) / 5) * 5;

let lastdept = null;

// Jis device ka data nahi aaya uska bhi khaali graph dikhana hai, isliye
// data[0] ko chhune se pehle guard. Fallback 65 wahi hai jo BaseGraph use
// karta hai.
if (!data || data.length === 0) {
    lastdept = 65;
} else if(rounded(data[0][1][2])=='115' || rounded(data[0][1][2])=='110' || rounded(data[0][1][2])=='135' || rounded(data[0][1][2])=='130' || rounded(data[0][1][2])=='140' || rounded(data[0][1][2])=='150'){
    lastdept = data[0][1][2];
} else {
    lastdept = data[0].slice(-1)[0][2];
}
//  lastdept = data[0].slice(-1)[0][2];
  

 

console.log(-rounded(lastdept) + parseFloat(66.5));
  useEffect(() => {
    graphData(deviceId)
      .then((res) => {
        let dp = res.data.jsondata;
        try {
          const parsed = typeof dp === "string" ? JSON.parse(dp) : dp;
          if (Array.isArray(parsed)) {
            setDatasets(parsed); // use directly if already formatted
          }
        } catch (error) {
          console.error("JSON parse error:", error);
        }
      })
      .catch((err) => console.error("Data fetch error:", err));
  }, [deviceId]);

      const series = useMemo(() => {
      return data.map((entry) => {
        const timestamp = entry[0];
        const dateStr = new Date(timestamp)
          .toLocaleString("en-US", { hour12: false })
          .slice(0, -6);
  
        const points = entry.slice(1).map((pt) => ({
          x: typeof pt[1] === "number" ? pt[1] : 0,
          y: typeof pt[2] === "string" ? parseFloat(pt[2]) : 0
        }));
  
        return {
          label: dateStr,
          data: points,
          borderColor: getRandomColor(),
          backgroundColor: getRandomColor(),
          tension: 0.2,
          yAxisID: "yDepth",
          pointRadius: 2
        };
      });
    }, [data]);
  

 
const maxPriorLeftX = -maximum;
const maxPriorRightX = maximum;

 const actionPriorLeftX = -action;
const actionPriorRightX = action;

const alarmLeftX =-alarm;
const alarmRightX =alarm;

 
const yTop = -5;
const yBottom = Math.min(...series.flatMap(s => s.data.map(p => p.y)), -65);

 const verticalLines = [

  {
    label: "Action Prior Stage",
    data: [
      { x: actionPriorLeftX, y: yBottom },
      { x: actionPriorLeftX, y: yTop }
    ],
    borderColor: "#ffd11e",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  },


  {
    label: "Action Prior Stage",
    data: [
      { x: actionPriorRightX, y: yBottom },
      { x: actionPriorRightX, y: yTop }
    ],
    borderColor: "#ffd11e",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  },

 
  {
    label: "Max Prior Stage",
    data: [
      { x: maxPriorLeftX, y: yBottom },
      { x: maxPriorLeftX, y: yTop }
    ],
    borderColor: "#ff8554",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  },

  
  {
    label: "Max Prior Stage",
    data: [
      { x: maxPriorRightX, y: yBottom },
      { x: maxPriorRightX, y: yTop }
    ],
    borderColor: "#ff8554",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  },

 
  {
    label: "Alarm",
    data: [
      { x: alarmLeftX, y: yBottom },
      { x: alarmLeftX, y: yTop }
    ],
    borderColor: "#808080",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  },

  
  {
    label: "Alarm",
    data: [
      { x: alarmRightX, y: yBottom },
      { x: alarmRightX, y: yTop }
    ],
    borderColor: "#808080",
    borderWidth: 2,
    pointRadius: 0,
    yAxisID: "yDepth"
  }
];





  const chartData = {
    datasets: [
         ...verticalLines,
   ...series,
   
    ]
  };

  const chartOptions = {
    elements: {
      point: {
        radius: 2
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false
    },
    // plugins: [customPressureTicksPlugin],
    scales: {
      x: {
        type: "linear",
        min: -3.0,
        max: 3.0,
        title: {
          display: true,
          text: "Deflection (inches)"
        },
        grid: {
          display: false
        }
      },
      yDepth: {
        position: "left",
        // min: roundDownToFive(parseFloat(lastdept)),
        max: 0,
        ticks: {
          stepSize: 5,
          callback: (val) => `${val}`
        },
        title: {
          display: true,
          text: "Depth (feet)"
        },
        grid: {
          drawOnChartArea: true,
          color: "#e0e0e0"
        }
      },
      yPressure: {
        position: "right",
         min:-rounded(lastdept) + parseFloat(66.5),
        max: 66.5,
        ticks: {
            stepSize: 5,
          callback: (val) => val.toFixed(1)
        },
        title: {
          display: true,
          text: "Elevation (feet)"
        },
        grid: {
          drawOnChartArea: true
        }
      }
    },
    plugins: {
      legend: {
        position: "top",
     labels: {
      usePointStyle: true,
        boxWidth: 5,
    boxHeight: 5,
      generateLabels: function(chart) {
        const datasets = chart.data && chart.data.datasets ? chart.data.datasets : [];
        const seen = new Set();
        const result = [];

        datasets.forEach((ds, idx) => {
          const label = ds.label != null ? String(ds.label) : `dataset ${idx}`;
          if (!seen.has(label)) {
            seen.add(label);
            result.push({
              text: label,
              fillStyle: ds.borderColor || ds.backgroundColor || "#000",
              strokeStyle: ds.borderColor || ds.backgroundColor || "#000",
              lineWidth: ds.borderWidth || 2,
              hidden: !!ds.hidden,
              // datasetIndex points to the FIRST dataset with this label.
              // Chart.js uses datasetIndex from legend item when toggling visibility.
              datasetIndex: chart.data.datasets.findIndex(d => (d.label == null ? "" : String(d.label)) === label)
            });
          }
        });

        return result;
      }
    }
      },
      tooltip: {
        enabled: true
      }
    }
  };

  return (
    <div className="graph" style={{ height: '800px', overflowY: 'auto' }}>
      <Line options={chartOptions} data={chartData} />
    </div>
  );
};

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export default RebaseISGraphChartjs;
